import "./assets/main.css"
import "tippy.js/dist/tippy.css"

import { createApp } from "vue"
import { createPinia } from "pinia"
import App from "./App.vue"
import { router } from "./router"
import VueFeather from "vue-feather"
import VueTippy, { useTippyComponent } from "vue-tippy"
import axios from "axios"
import { LongpressDirective } from "./directives/longpress"
import { FocusDirective } from "./directives/focus"

// This property ensures that axios instructs the browser to please send any
// credentials (which includes cookies) to the server on every request, which
// includes our session cookie. NOTE: This has no effect on same-origin requests
// (= the client is served from the same domain as the server), but this allows
// admins to host the backend server at a different URL than the frontend script
// and it will still work. Currently, the app is not configured to do so except
// in development, but having this means we can't forget it in the future.
// c.f.: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials
axios.defaults.withCredentials = true

// In development, we need to access a different server (Vite will serve the
// frontend from one port, the backend runs on another port).
try {
  if (__APP_MODE__ !== "production" && __DEV_SERVER_PORT__ !== undefined) {
    const serverUrl = `http://${window.location.hostname}:${__DEV_SERVER_PORT__}`
    console.warn(`Setting Axios base URL to ${serverUrl}`)
    axios.defaults.baseURL = serverUrl
  }
} catch (err) {
  // We're in production
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
const app = createApp(App)

app.use(createPinia())
app.use(router)
// eslint-disable-next-line vue/component-definition-name-casing
app.component("vf-icon", VueFeather)
app.use(VueTippy)
// eslint-disable-next-line vue/multi-word-component-names
app.component("Tippy", useTippyComponent)

// This code adds a custom directive `v-focus`, that can be added to any
// element. As soon as an element with this directive is mounted into the dom,
// this will move focus there. Thanks to https://stackoverflow.com/a/67576157.
// Huh, also found the docs afterwards: https://vuejs.org/guide/reusability/custom-directives.html#when-to-use
app.directive("focus", FocusDirective)
app.directive("longpress", LongpressDirective)

app.mount("#app")
